import moment from "moment-jalaali";

export const getAngle = (origin, destination) => {
    return 180 + (Math.atan2(destination[0] - origin[0], destination[1] - origin[1]) * 180) / Math.PI;
};

export const timeDuration = (Start, End) => {
    let result = "";

    const duration = moment.duration(moment(End).diff(moment(Start)));

    if (duration.months() > 1) result = duration.months() + " ماه";
    else if (duration.days() > 1) result = duration.days() + " روز";
    else if (duration.hours() > 1) result = duration.hours() + " ساعت";
    else if (duration.minutes() > 1) result = duration.minutes() + " دقیقه";

    return result;
};

export const formatDateTime = (Date) => {};
